import React from "react";
import { InsightsReportButton } from "./InsightsReportButton";
import { InsightsReportDTO } from "groopit-js/client";
import { InsightsReportViewer } from "./InsightsReportViewer";
import { InsightsReportEditor } from "./InsightsReportEditor";
import { InsightsFeed } from "./InsightsFeed";
import { ThemeProvider } from "@material-ui/core";
import { aiTheme } from "../styles/MaterialGroopTheme";
import { useInsightsPanelContext } from "./InsightsPanelContext";
import { InsightsChatPanel } from "./InsightsChatPanel";
import { ChatWithYourData } from "../Ai/ChatWithYourData/ChatWithYourData";

export const InsightsPanelTitle = "AI insights";

interface InsightsPanelProps {
  variant: "modal" | "column";
}

export const InsightsPanel = (props: InsightsPanelProps): JSX.Element => {
  const { variant } = { ...props };
  const insightsPanelContext = useInsightsPanelContext();

  const includeHiddenWarning = () => {
    return (
      insightsPanelContext.selectedReport &&
      !insightsPanelContext.selectedReport.isEditMode &&
      insightsPanelContext.selectedReport.report instanceof InsightsReportDTO &&
      insightsPanelContext.selectedReport.report.includesHiddenData
    );
  };
  const chooseContent = () => {
    if (insightsPanelContext.isGeneratingReport) {
      return (
        <InsightsChatPanel
          filter={insightsPanelContext.isGeneratingReport.filter}
          groopitCount={insightsPanelContext.isGeneratingReport.groopitCount}
        />
      );
    } else if (
      insightsPanelContext.selectedReport?.report instanceof InsightsReportDTO
    ) {
      if (insightsPanelContext.selectedReport.isEditMode) {
        return (
          <InsightsReportEditor
            report={insightsPanelContext.selectedReport.report}
            isNewlyCreated={insightsPanelContext.selectedReport.isNewlyCreated}
          />
        );
      } else {
        return (
          <InsightsReportViewer
            {...props}
            report={insightsPanelContext.selectedReport.report}
            isThumbnailView={false}
          />
        );
      }
    } else {
      return <InsightsFeed />;
    }
  };

  return (
    <ThemeProvider theme={aiTheme}>
      <div
        className={variant === "modal" ? "" : "border-app-slateblue border-t-8"}
      >
        <div
          className={
            variant === "modal"
              ? ""
              : "border-app-gray-08 border border-l-2 border-r-2 rounded rounded-t-none w-full"
          }
        >
          {variant === "column" && (
            <div className="h-18 border-app-gray-08 border-b-2 w-full px-4 flex items-center bg-app-slateblue-x-light">
              <div className="text-display-title text-color-secondary flex-grow">
                {InsightsPanelTitle}
              </div>
              <div>
                <InsightsReportButton />
              </div>
            </div>
          )}
          <ChatWithYourData />
          <div>
            {includeHiddenWarning() && (
              <div className="bg-app-teal-x-light text-xs border-app-gray-08 border-b-1 border-t-1 py-2 px-4">
                <b>Note:</b> The summary insight contains information from
                hidden data fields. To maintain confidentiality, this insight
                cannot be promoted or published to the group.
              </div>
            )}
            <div className="p-4">{chooseContent()}</div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};
